import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Debug/migration utilities (window-exposed console helpers) are loaded lazily
// after mount in App.js so they stay out of the initial bundle.

// Global error handler for IndexedDB issues
window.addEventListener("error", (event) => {
  if (
    event.message &&
    (event.message.includes("IndexedDB") ||
      event.message.includes("IDBDatabase") ||
      event.message.includes("Internal error opening backing store"))
  ) {
    console.warn("IndexedDB error detected - Firebase may be using fallback cache");
    event.preventDefault(); // Prevent error from crashing the app
  }
});

// Handle unhandled promise rejections for IndexedDB
window.addEventListener("unhandledrejection", (event) => {
  if (
    event.reason &&
    event.reason.message &&
    (event.reason.message.includes("IndexedDB") ||
      event.reason.message.includes("IDBDatabase") ||
      event.reason.message.includes("Internal error opening backing store"))
  ) {
    console.warn("IndexedDB promise rejection - Firebase using fallback cache");
    event.preventDefault();
  }
});

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// import React from "react";
// import ReactDOM from "react-dom";
// import App from "./App";
// import { OwnerProvider } from "./context/OwnerContext";

// ReactDOM.render(
//   <OwnerProvider>
//     <App />
//   </OwnerProvider>,
//   document.getElementById("root")
// );
